// src/data/features.ts
import { Monitor, Waves, SatelliteAlt, Analytics, Biotech, WarningAmber } from '@mui/icons-material';

export interface Feature {
  icono: typeof Monitor; // o cualquier icono de MUI
  title: string;
  description: string;
  color: string;
}

export const features: Feature[] = [
  {
    icono: Monitor,
    title: 'Monitorización en tiempo real',
    description:
      'Sistemas avanzados para el monitoreo continuo de parámetros de calidad del agua con transmisión de datos en tiempo real y alertas automáticas.',
    color: '#1e40af',
  },
  {
    icono: Waves,
    title: 'Boyas instrumentadas multiparamétricas',
    description:
      'Boyas especializadas equipadas con sensores multiparamétricos para medición continua en ambientes marinos y fluviales.',
    color: '#10b981',
  },
  {
    icono: SatelliteAlt,
    title: 'Teledetección satelital',
    description:
      'Análisis de masas de agua mediante imágenes satelitales y procesamiento avanzado de datos de teledetección.',
    color: '#8b5cf6',
  },
  {
    icono: Analytics,
    title: 'Plataformas de análisis ambiental',
    description:
      'Plataformas integradas para la adquisición, procesamiento y análisis comprehensivo de datos ambientales.',
    color: '#f59e0b',
  },
  {
    icono: Biotech,
    title: 'Sensores especializados',
    description:
      'Sensores de alta precisión para medición de parámetros fisicoquímicos y biológicos en diversos ambientes acuáticos.',
    color: '#ef4444',
  },
  {
    icono: WarningAmber,
    title: 'Detección temprana de hidrocarburos',
    description:
      'Sistemas de monitoreo que detectan la presencia de hidrocarburos en piscifactorías, permitiendo alertas inmediatas y medidas preventivas para proteger la fauna acuática.',
    color: '#f97316',
  },
];
